export default __webpack_public_path__ + "static/media/driveway-concrete.7f644578.jpg";